import { useFormContext } from 'react-hook-form';
import { FormControlLabel, TextField } from '@mui/material';
import { InfoFormLabel } from '~/components';
import { useHasLockedStatus } from '~/hooks/dataset';
import { MAX_PROVENANCE_LENGTH } from '~/validation/datasetSchema';

const ProvenanceField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { hasLockedStatus } = useHasLockedStatus();

  return (
    <FormControlLabel
      label={
        <InfoFormLabel
          label="PROVENANCE"
          tooltipText="Data provenance is a record of a dataset's origin, including all the processes, activities, and people involved in its creation, movement, and transformation."
        />
      }
      required
      control={
        <TextField
          multiline
          minRows={2}
          maxRows={6}
          {...register('provenance')}
          error={!!errors.provenance}
          helperText={(errors.provenance?.message as string) || `Max ${MAX_PROVENANCE_LENGTH} characters`}
          disabled={hasLockedStatus}
          slotProps={{ htmlInput: { maxLength: MAX_PROVENANCE_LENGTH } }}
        />
      }
    />
  );
};

export default ProvenanceField;
